import RequestBuilder from './RequestBuilder';
import IBaseRepository from './IBaseRepository';
import { IKeyValue } from '@/Instructure/baseModels/IKeyValue';

export default class BaseRepository implements IBaseRepository {
    private baseUrl = '';
    private defualtHeader = <object>{};
    private controller = '';

    constructor(baseUrl: string, defualtHeader?: object, controller?: string) {
        this.baseUrl = baseUrl;

        if (defualtHeader) {
            this.defualtHeader = defualtHeader;
        }

        if (controller) {
            this.controller = controller;
        }
    }

    protected CreateRequestBuilder(): RequestBuilder {
        return new RequestBuilder()
            .setBaseUrl(this.baseUrl)
            .SetHeader(this.defualtHeader);
    }

    async getAll(queryParams?:  IKeyValue[]) {
        let builder = this.CreateRequestBuilder()
            .setMothod('get')
            .setUrl(this.controller);
        if (queryParams) {
            queryParams.forEach((element) => {
                builder = builder.addQueryParam(element.key, element.value);
            });
        }

        return await builder.GetResultAsync();
    }

    async byId(id: string | number, queryParams?: IKeyValue []) {
        let builder = this.CreateRequestBuilder()
            .setMothod('get')
            .setUrl('{controller}/{id}', {controller: this.controller, id});
        if (queryParams) {
            queryParams.forEach((element) => {
                builder = builder.addQueryParam(element.key, element.value);
            });
        }

        return await builder.GetResultAsync();
    }

    async create(body?: any, queryParams?: IKeyValue[]) {
        let builder = this.CreateRequestBuilder()
            .setMothod('post')
            .setUrl('{controller}', {controller: this.controller});
        if (queryParams) {
            queryParams.forEach((element) => {
                builder = builder.addQueryParam(element.key, element.value);
            });
        }

        if (body) {
            builder = builder.setBody(body);
        }

        return await builder.GetResultAsync();
    }

    async edit(id: string | number, body?: any, queryParams?: IKeyValue[]) {
        let builder = this.CreateRequestBuilder()
            .setMothod('put')
            .setUrl('{controller}/{id}', {controller: this.controller, id});
        if (queryParams) {
            queryParams.forEach((element) => {
                builder = builder.addQueryParam(element.key, element.value);
            });
        }

        if (body) {
            builder = builder.setBody(body);
        }

        return await builder.GetResultAsync();
    }

    async delete(id: string | number, queryParams?:  IKeyValue[]) {
        let builder = this.CreateRequestBuilder()
            .setMothod('delete')
            .setUrl('{controller}/{id}', {controller: this.controller, id});
        if (queryParams) {
            queryParams.forEach((element) => {
                builder = builder.addQueryParam(element.key, element.value);
            });
        }

        return await builder.ExcuteAsync();
    }
}
